/** @format */
import {
    largeDesktop,
    largeTablet,
    mobile,
    smallMobile,
    smallTablet,
} from '@mpb-com/feather/helpers/media-queries';
import styled, { css } from 'styled-components';

import {
    SectionPreviewBlockImagePosition,
    SectionPreviewBlockVariant,
} from '@toucan/client/core/contentful';

import { StyledSectionPreviewBlockProps } from './types';

export const StyledSectionPreviewBlock = styled.div<StyledSectionPreviewBlockProps>`
    /* We always want this to be full width, so break out of the constrained wrapper */
    grid-column: 1 / -1;
    ${blockVariantStyles}

    .content-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: var(--layout-spacing-32);
        min-height: 40rem;

        .image {
            display: flex;
            justify-content: center;
            grid-area: image;
            width: 100%;
            position: relative;

            picture {
                display: flex;
                position: absolute;
                top: 0;
                bottom: 0;
            }

            img {
                width: 100%;
                object-fit: cover;
            }
        }

        .content {
            grid-area: content;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: var(--layout-spacing-48) 0;

            .heading {
                margin-bottom: var(--layout-spacing-8);
            }

            .text {
                margin: 0;
                color: var(--colors-text-inverse);
            }
        }

        .button {
            width: min-content;
            margin-top: var(--layout-spacing-24);

            button {
                width: 30rem;
            }
        }

        ${imageVariantStyles}

        ${largeDesktop(css`
            column-gap: var(--layout-spacing-48);
            min-height: 48.5rem;
        `)};

        ${largeTablet(css`
            column-gap: var(--layout-spacing-24);
            min-height: 33rem;
        `)}

        ${smallTablet(css`
            grid-template-areas: 'content' 'image';
            grid-template-columns: 1fr;
            grid-template-rows: auto auto;

            .image {
                max-height: 30rem;

                picture {
                    position: relative;
                }

                img {
                    object-fit: contain;
                }
            }

            .button {
                width: 100%;

                button {
                    width: 100%;
                }
            }
        `)}

         ${mobile(css`
            .content {
                padding: var(--layout-spacing-24) 0;
            }
        `)}

        ${smallMobile(css`
            .content {
                padding: var(--layout-spacing-24) 0;
            }
        `)}
    }
`;

function blockVariantStyles({ variant }: StyledSectionPreviewBlockProps) {
    switch (variant) {
        case SectionPreviewBlockVariant.SUSTAINABILITY:
            return `
                    background: var(--colors-sustainability);
                `;
        case SectionPreviewBlockVariant.FLAME:
            return `
                    background: var(--gradients-brand-primary);
                `;
        default:
            return '';
    }
}

function imageVariantStyles({
    imagePosition: imageVariant,
}: StyledSectionPreviewBlockProps) {
    switch (imageVariant) {
        case SectionPreviewBlockImagePosition.RIGHT:
            return `grid-template-areas: 'content image';`;
        case SectionPreviewBlockImagePosition.LEFT:
        default:
            return `grid-template-areas: 'image content';`;
    }
}
